import { useDictionary } from './useDictionary';
import type { HotAssets } from '@/shared/types';

const useHotAssetsDictionary = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const query = useDictionary<HotAssets>({
    dictionaryName: 'hotassets',
    enabled,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    isError: query.isError,
  };
};

export { useHotAssetsDictionary };
